// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard_container_main {
  display: flex;    
  }

  .dashboard_left_container{
    border-right: 1px solid #e5e9ec;
  }  

.dashboard_container_main .dashboard_right_container {
    flex-grow: 1;
    min-width: 0;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
    height: 100vh;
  }
  .dashboard_right_container .dashboard_content_container {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      /* Let route roots (e.g. People) use flex: 1 + min-height: 0 to fill height and scroll inside */
      display: flex;
      flex-direction: column;
    }`, "",{"version":3,"sources":["webpack://./src/components/mainDashboardContainer/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb;;EAEA;IACE,+BAA+B;EACjC;;AAEF;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,aAAa;EACf;EACA;MACI,OAAO;MACP,aAAa;MACb,gBAAgB;MAChB,+FAA+F;MAC/F,aAAa;MACb,sBAAsB;IACxB","sourcesContent":[".dashboard_container_main {\n  display: flex;    \n  }\n\n  .dashboard_left_container{\n    border-right: 1px solid #e5e9ec;\n  }  \n\n.dashboard_container_main .dashboard_right_container {\n    flex-grow: 1;\n    min-width: 0;\n    max-width: 100%;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    height: 100vh;\n  }\n  .dashboard_right_container .dashboard_content_container {\n      flex: 1;\n      min-height: 0;\n      overflow-y: auto;\n      /* Let route roots (e.g. People) use flex: 1 + min-height: 0 to fill height and scroll inside */\n      display: flex;\n      flex-direction: column;\n    }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
